export const CBACSPConfig = {
  cspConfiguration: {
    partner: 'cba',
    partnerTitle: 'CBA Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'cba-sit-petportal-auth.petsure.com.au',
        appClientId: '2L1iIBpeVQrGvVeCjBdCE5xKuNjT2oCK',
        cspMfaUrl: 'https://cba-sit-petportal.au.auth0.com/mfa/'
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'cba-uat-petportal-auth.petsure.com.au',
        appClientId: '4tX9CYiw8c2EiOJhmIs9Qv7NSQIxbgHQ',
        cspMfaUrl: 'https://cba-uat-petportal.au.auth0.com/mfa/'
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'cba-preprod-petportal-auth.petsure.com.au',
        appClientId: 'XXXX',
        cspMfaUrl: 'https://cba-preprod-petportal.au.auth0.com/mfa/'
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'cba-petportal-auth.petsure.com.au',
        appClientId: 'XXXX',
        cspMfaUrl: 'https://cba-petportal.au.auth0.com/mfa/'
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'cbainsurance.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'cbainsurance.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'cbainsurance.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'cbainsurance.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      prod: 'https://assets.commbank.com.au/is/image/commbank/A_422831178?$Responsive_Align_Center_Top$&fit=constrain&wid=1278&dpr=off'
    },
    footerLogo: {
      prod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp-assets-petsure-preprod/images/footer/footer_bw_pia.png',
        imageTitle: 'Pet Insurance Australia',
        imageTitleDescription: 'Pet Insurance Australia'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: true
  }
};
